class Popup {
  constructor () {
    this.hover = null;
    this.nonHhover = null;
    this.active = null;
    this.popup = null;
    this.closeBtn = null;
    this.showBtn = null;
    this.showMovie = false;
    this.showCharactor = false;
    this.showSports = false;
    this.showTalent = false;
    this.popupMovie = false;
    this.popupCharactor = false;
    this.popupSports = false;
    this.popupTalent = false;
    this.isDeskTop = false;
    this.businessCircle = false;
  }

  init () {
    this.default = document.querySelectorAll(".business__default");
    this.active = document.querySelectorAll(".business__hover--active");
    this.hover = document.querySelectorAll(".business__hover");
    this.closeBtn = document.querySelectorAll('.js-close-btn');
    this.showMovie = document.querySelector('.js-showMovie');
    this.showCharactor = document.querySelector('.js-showCharacter');
    this.showSports = document.querySelector('.js-showSports');
    this.showTalent = document.querySelector('.js-showTalent');
    this.popupMovie = document.querySelector('.js-popupMovie');
    this.popupCharactor = document.querySelector('.js-popupCharacter');
    this.popupSports = document.querySelector('.js-popupSports');
    this.popupTalent = document.querySelector('.js-popupTalent');

    this.businessImage = document.querySelector('.business__image');
    this.business = document.querySelector('.business');
    this.businessCircle = document.querySelector('.business__container');

    if (window.parent.screen.width >= 768) {
      this.isDeskTop = true;
    }
    this.addEvent();
  }

  addEvent () {
    for (let i = 0; i < this.default.length; i++) {
      if (this.isDeskTop) {
        // カーソルのせたら
        this.default[i].addEventListener("mouseenter", e => {
          if (this.default[i].contains(e.relatedTarget)) return;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
            // 拡大
            this.hover[i].classList.add("business__hover--active");
            // 元のは消える
            this.default[i].classList.add("business__default--none");
        });
        this.hover[i].addEventListener("mouseleave", e => {
          if (this.hover[i].contains(e.relatedTarget)) return;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          // hoverしたの外す
          this.hover[i].classList.remove("business__hover--active");
          // 元に戻す
          this.default[i].classList.remove("business__default--none");
          e.preventDefault();
        });
      } else {
        // SPの時はクリックで拡大
        this.default[i].addEventListener("click", () => {
          // 拡大
          this.hover[i].classList.add("business__hover--active");
          // 元のは消える
          this.default[i].classList.add("business__default--none");
        }, true);
        // 外側をクリックしたら元に戻る
        this.business.addEventListener("click", e => {
            this.hover[i].classList.remove("business__hover--active");
            // 元に戻す
            this.default[i].classList.remove("business__default--none");
        }, true);
      }
      // hover終わったら
      this.hover[i].addEventListener('animationend', e => {
          if (this.hover[i].contains(e.relatedTarget)) return;
        e.stopPropagation();
        e.preventDefault();
        for (let i = 0; i < this.hover.length; i++) {
          // カーソル外したら
          this.hover[i].addEventListener("mouseleave", e => {
            // hoverしたの外す
            this.hover[i].classList.remove("business__hover--active");
            // 元に戻す
            this.default[i].classList.remove("business__default--none");
            return false;
          });
        }
        // 映画アニメをクリックしたら
        this.showMovie.addEventListener('click', e => {
          if (e.target !== e.currentTarget) { 
          if (this.showMovie.contains(e.relatedTarget)) return;
          // ズームする
          this.businessCircle.classList.add('business__container--showMovieZoom');
          // ズーム終わったら
          this.businessCircle.addEventListener('animationend', e => {
          if (e.target === e.currentTarget) { 
          e.stopPropagation();
          e.preventDefault();
            // ポップアップだす
            this.popupMovie.classList.add('popup__show');
            this.popupCharactor.classList.remove('popup__show');
            this.popupSports.classList.remove('popup__show');
            this.popupTalent.classList.remove('popup__show');
            e.stopPropagation();
          e.preventDefault();
          }
          });
          e.stopPropagation();
          e.preventDefault();
        }
          return false;
        });

        // キャラクタービジネスクリックしたら
        this.showCharactor.addEventListener('click', e => {
          if (e.target !== e.currentTarget) { 
            if (this.showCharactor.contains(e.relatedTarget)) return;
          e.stopPropagation();
          e.preventDefault();
          e.stopImmediatePropagation();
          // ズームする
          this.businessCircle.classList.add('business__container--showCharactorZoom');
          // ズーム終わったら
          this.businessCircle.addEventListener('animationend', e => {
            if (e.target === e.currentTarget) { 
            e.stopPropagation();
          e.preventDefault();
          // ポップアップだす
          this.popupCharactor.classList.add('popup__show');
          this.popupMovie.classList.remove('popup__show');
          this.popupSports.classList.remove('popup__show');
          this.popupTalent.classList.remove('popup__show');
          e.stopPropagation();
          e.preventDefault();
            }
          });
          e.stopPropagation();
          e.preventDefault();
        }
          return false;
        });

        this.showSports.addEventListener('click', e => {
          e.stopPropagation();
          if (this.popupSports) {
            this.businessCircle.classList.add('business__container--showSportsZoom');
            this.businessCircle.addEventListener('animationend', e => {
              if (e.target === e.currentTarget) { 
              e.stopPropagation();
              e.preventDefault();
              this.popupSports.classList.add('popup__show');
              this.popupMovie.classList.remove('popup__show');
              this.popupCharactor.classList.remove('popup__show');
              this.popupTalent.classList.remove('popup__show');
              e.stopPropagation();
          e.preventDefault();
              }
            });
          }
          return false
        });

        this.showTalent.addEventListener('click', e => {
          e.stopPropagation();
          this.businessCircle.classList.add('business__container--showTalentZoom');
            this.businessCircle.addEventListener('animationend', e => {
              if (e.target === e.currentTarget) { 
              e.stopPropagation();
              e.preventDefault();
              this.popupTalent.classList.add('popup__show');
              this.popupMovie.classList.remove('popup__show');
              this.popupCharactor.classList.remove('popup__show');
              this.popupSports.classList.remove('popup__show');
              e.stopPropagation();
          e.preventDefault();
              }
            });
            return false;
        });

        for (let i = 0; i < this.default.length; i++) {
          // ポップアップの閉じるボタン押したら
          this.closeBtn[i].addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            // ズームしたの全部外す
            this.businessCircle.classList.remove('business__container--showMovieZoom');
            this.businessCircle.classList.remove('business__container--showCharactorZoom');
            this.businessCircle.classList.remove('business__container--showSportsZoom');
            this.businessCircle.classList.remove('business__container--showTalentZoom');
            // ポップアップ消す
            this.popupMovie.classList.remove('popup__show');
            this.popupCharactor.classList.remove('popup__show');
            this.popupSports.classList.remove('popup__show');
            this.popupTalent.classList.remove('popup__show');
            this.hover[i].classList.remove("business__hover--active");
            // 元に戻す
            this.default[i].classList.remove("business__default--none");
          });
        }

        for (let i = 0; i < this.hover.length; i++) {
          // カーソル外したら
          this.hover[i].addEventListener("mouseleave", e => {
            if (this.hover[i].contains(e.relatedTarget)) return;
            e.preventDefault();
            e.stopPropagation();
            // hoverしたの外す
            this.hover[i].classList.remove("business__hover--active");
            // 元に戻す
            this.default[i].classList.remove("business__default--none");
            e.stopPropagation();
            return false;
          });
        }
      });

      for (let i = 0; i < this.hover.length; i++) {
        // カーソル外したら
        this.hover[i].addEventListener("mouseleave", e => {
          if (this.hover[i].contains(e.relatedTarget)) return;
          e.preventDefault();
          e.stopPropagation();
          // hoverしたの外す
          this.hover[i].classList.remove("business__hover--active");
          // 元に戻す
          this.default[i].classList.remove("business__default--none");
          e.stopPropagation();
          return false;
        });
      }
    };
  }
};

const popup = new Popup();
popup.init();
